export enum AgencyServiceDeliveryModel {
  SaaS = 'SaaS',
  FullyManaged = 'fully_managed',
}
